import { API_URL } from 'src/constants';
import { fetch } from '../fetchWrapper/fetch';
import { GetUserVenueAccessResponse } from './types';

export const getUserVenueAccess = async (userId: string): Promise<GetUserVenueAccessResponse> => {
  const uri = `${API_URL}/admin/users/${userId}/venue-access`;

  const response = await fetch(uri);
  if (!response.ok) {
    throw new Error('Could not fetch venue access');
  }
  return response.json();
};
